export default __webpack_public_path__ + "files/1_3_5_Questionnaire.docx";